module.exports = __webpack_public_path__ + "img/logoCA.53cad2b3.png";